import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=642ffdab"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports